import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import StepUpPanel from "../mfa/StepUpPanel";
import { Alert, Card, Field, btn, input, primary } from "../workforce/common";

const msg = (e) => e?.response?.data?.detail?.message || "Something went wrong.";

// Close / override / archive / reopen. The server decides; buttons only appear for roles that can use them.
export default function CloseControls({ data, pid, reload }) {
  const { user } = useAuth();
  const role = user?.role_key;
  const founder = role === "OWNER_SUPER_ADMIN";
  const manager = founder || ["ADMINISTRATOR", "PROJECT_MANAGER"].includes(role);
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState(null);
  const [stepUp, setStepUp] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { if (founder) api.get("/mfa/status").then((r) => setStatus(r.data)).catch(() => {}); }, [founder]);
  const token = stepUp && stepUp.until > Date.now() ? stepUp.token : null;
  const hdr = token ? { headers: { "X-MFA-StepUp": token } } : undefined;
  const run = (p) => p.then(() => { setErr(""); setReason(""); reload(); }).catch((e) => setErr(msg(e)));
  if (!manager) return null;
  const closed = data.read_only;
  const needsOverride = !data.complete && !closed;
  return (
    <Card testid="co-controls" className="space-y-2">
      <h2 className="font-heading text-lg">{closed ? "Project is closed" : "Close the project"}</h2>
      {!closed && data.complete && <button type="button" className={primary} onClick={() => run(api.post(`/closeout/projects/${pid}/close`, {}))} data-testid="co-close">Close project</button>}
      {needsOverride && !founder && <p className="text-sm" data-testid="co-close-blocked">Finish the open items first. Only the Founder can close with open items.</p>}
      {((needsOverride && founder) || (closed && founder)) && (
        <div className="space-y-2">
          {status && <StepUpPanel status={status} stepUp={stepUp} setStepUp={setStepUp} />}
          <Field id="co-reason" label={closed ? "Reason to reopen" : "Override reason (open items are recorded)"}>
            <textarea id="co-reason" className={input} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="co-reason" /></Field>
          {closed
            ? <button type="button" className={btn} disabled={!token} onClick={() => run(api.post(`/closeout/projects/${pid}/reopen`, { reason }, hdr))} data-testid="co-reopen">Reopen project</button>
            : <button type="button" className={btn} disabled={!token} onClick={() => run(api.post(`/closeout/projects/${pid}/close`, { override_reason: reason }, hdr))} data-testid="co-override">Close with override</button>}
        </div>)}
      {closed && founder && data.project_status === "closed" && <button type="button" className={btn} onClick={() => run(api.post(`/closeout/projects/${pid}/archive`))} data-testid="co-archive">Archive</button>}
      <Alert text={err} testid="co-controls-error" />
    </Card>
  );
}
